import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface tossPayState {
  userId: string;
  amount: number;
  requestPayments: {
    orderId: string;
    orderName: string;
    successUrl: string;
    failUrl: string;
  } | null;
}

const initialTossPayState: tossPayState = {
  userId: '',
  amount: 0,
  requestPayments: null,
};

const tossPaySlice = createSlice({
  name: 'tossPay',
  initialState: initialTossPayState,
  reducers: {
    setTossPay: (state, action: PayloadAction<tossPayState>) => {
      state.userId = action.payload.userId;
      state.amount = action.payload.amount;
      state.requestPayments = action.payload.requestPayments;
    },
  },
});

export const { setTossPay } = tossPaySlice.actions;

export default tossPaySlice.reducer;
